import axios from "@/http";
import { handleGetRequestParams } from '@/common/js/util'

class SingleQuantity {
  /* 单量录入列表 */
  static getSingleQuantityEntryList(options) {
    let url = `/zwy/api/order/num/import/order/num/page?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 实际单量列表 */
  static getActualList(options) {
    let url = `/zwy/api/order/num/import/receive/order/num/list?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 预计单量列表 */
  static getForecastList(options) {
    let url = `/zwy/api/order/num/import/expect/order/num/list?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 保存实际单量 */
  static postSaveActual(data) {
    let url = `/zwy/api/order/num/import/receive/order/num/save`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 保存预计单量 */
  static postSaveForecast(data) {
    let url = `/zwy/api/order/num/import/expect/order/num/save`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default SingleQuantity;